import { Ic } from './Icon';
import { SectionHead, delay } from './Section';
import type { LandingContent } from './content';

/** Placeholder quotes: replace with real customers before production. */
export function TestimonialsSection({ c }: { c: LandingContent }) {
  return (
    <section className="lp-section" id="testimonials">
      <div className="lp-container">
        <SectionHead eyebrow={c.quotes.eyebrow} title={c.quotes.title} />
        <div className="quotes">
          {c.quotes.items.map((q, i) => (
            <article className="lp-card quote" data-reveal key={q.n} style={delay(i * 100)}>
              <div className="stars" aria-label="5 / 5">
                {Array.from({ length: 5 }, (_, j) => (
                  <Ic name="star" key={j} />
                ))}
              </div>
              <p>“{q.q}”</p>
              <div className="who">
                <span className="av">{q.i}</span>
                <span>
                  <b>{q.n}</b>
                  <span>{q.r}</span>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
